import { useNavigate, useParams } from 'react-router-dom';

export interface AdditionalWorkflowLaunchNavigator {
  openGroupsPage: () => void;
  openConflictsPage: () => void;
  openKeyDateTasksPage: () => void;
  openAllTasksPage: () => void;
  openPartiesPage: () => void;
  openProjectPage: (afterLaunch?: boolean) => void;
  openFirstStep: (hasGroups: boolean) => void;
}

export default function useAdditionalWorkflowLaunchNavigator(): AdditionalWorkflowLaunchNavigator {
  const navigator = useNavigate();
  const params = useParams();

  const projectId = params.id!;
  const planId = params.planId!;
  const basePath = `/transactions/${projectId}/plans/${planId}/launch`;

  const openGroupsPage = () => {
    navigator(`${basePath}/groups`);
  };

  const openConflictsPage = () => {
    navigator(`${basePath}/conflicts`);
  };

  const openKeyDateTasksPage = () => {
    navigator(`${basePath}/keydates`);
  };

  const openAllTasksPage = () => {
    navigator(`${basePath}/alltasks`);
  };

  const openPartiesPage = () => {
    navigator(`${basePath}/parties`);
  };

  const openProjectPage = (afterLaunch?: boolean) => {
    let uri = `/transactions/${projectId}`;
    if (afterLaunch) {
      uri += '?afterLaunch=1';
    }
    navigator(uri);
  };

  const openFirstStep = (hasGroups: boolean) => {
    if (hasGroups) {
      openGroupsPage();
    } else {
      openKeyDateTasksPage();
    }
  };

  return {
    openGroupsPage,
    openConflictsPage,
    openKeyDateTasksPage,
    openAllTasksPage,
    openPartiesPage,
    openProjectPage,
    openFirstStep,
  };
}
